<template>
  <div>
    <campaigns-chart
      :project-id="this.$route.query.project_id"
      :start-date="dateFrom"
      :end-date="dateTo"
      :items="chartItems"
      :channel="channel"
      :is-campaign-variant="true"
      :is-workflow-campaign="isWorkflowCampaign"
      class="chart-ct"
      :class="{ hidden: !showGraph }"
      :export-table-method="exportTableMethod"
      :key="key"
    >
      <expandable-control
        class="expandable-el-card"
        :open-text="$t('AnalyticsCampaignsPage_Graph_Show')"
        :close-text="$t('AnalyticsCampaignsPage_Graph_Hide')"
        @toggle="toggleGraph"
      />
    </campaigns-chart>
    <rest-list
      :payload="fetchEndpoint"
      @dataLoaded="setData($event)"
      @selection-change="handleSelectionChange($event)"
    >
      <template v-if="data[0]">
        <el-table-column type="selection" width="40" />
        <rest-list-column
          prop="title"
          :title="$t('CampaignChannelAnalytics_Table_Variant')"
          :min-width="200"
          :filter-input="false"
          fixed
        >
          <template slot-scope="scope">
            <i class="el-icon-trophy" v-if="scope.row.fields.key === 'W'" />
            {{ variantLabel(scope.row, true) }}
            <i
              v-if="parseInt(scope.row.fields.winner)"
              class="winner el-icon-trophy"
            />
          </template>
        </rest-list-column>
        <rest-list-column
          v-if="hasCustomVariantsShare"
          prop="fields.split_percentage"
          :title="$t('CampaignChannelAnalytics_Table_Variant_Split_Percentage')"
          :min-width="200"
          :filter-input="false"
          fixed
        >
          <template v-slot="scope">
            {{ scope.row.fields.split_percentage }}
          </template>
        </rest-list-column>
        <rest-metric-group
          v-for="(metricGroup, metricIndex) in data[0].metricGroups"
          :key="metricIndex"
          :metric-group="metricGroup"
          :prop="'metricGroups[' + metricIndex + ']'"
        />
      </template>
    </rest-list>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestMetricGroup from '@/common/components/rest/RestMetricGroup'
import CampaignsChart from '@/modules/analytics/components/CampaignsChart'
import { projectEndpoint } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import moment from 'moment'
import ExpandableControl from '@/modules/analytics/components/ExpandableControl'

export default {
  name: 'StatisticsTab',

  components: {
    ExpandableControl,
    RestList,
    RestListColumn,
    RestMetricGroup,
    CampaignsChart
  },

  mounted() {
    EventBus.$on('common/components/dashboard/DateFilter:onChange', event => {
      this.dateFrom = moment(event.start).format('YYYY-MM-DD')
      this.dateTo = moment(event.end).format('YYYY-MM-DD')
    })

    const endpoint = {
      method: 'get',
      url: `campaigns/${this.campaignId}`,
      params: { expand: 'type,custom_variant_share' }
    }
    RestApi(projectEndpoint(endpoint)).then(({ data }) => {
      this.campaignType = data.type
      this.hasCustomVariantsShare = !!data.custom_variant_share
      this.key = new Date().getTime() // refresh the chart
    })
  },

  data() {
    return {
      data: [],
      chartItems: {},
      dateFrom: this.$route.query.date_from || '',
      dateTo: this.$route.query.date_to || '',
      showGraph: false,
      campaignType: null,
      key: '',
      hasCustomVariantsShare: false
    }
  },

  methods: {
    setData(event) {
      this.data = event
    },
    toggleGraph(isOpen) {
      this.showGraph = isOpen
    },
    handleSelectionChange(selectedItems) {
      this.chartItems = {}

      selectedItems.forEach((val, key) => {
        this.chartItems[val.fields.id] = {
          id: val.fields.id,
          title: `${this.variantLabel(val)}`,
          transformed: true
        }
      })
    },
    variantLabel(row, withoutW = false) {
      let label = row.fields.key
      if (withoutW && row.fields.key === 'W') {
        label = ''
      }

      if (row.fields.title && row.fields.title.length) {
        label += ' – ' + row.fields.title
      }
      if (row.fields.action && row.fields.action.length) {
        label += ' – ' + row.fields.action
      }
      return label
    }
  },

  computed: {
    campaignId() {
      return this.$route.query.id || null
    },

    channel() {
      return this.$route.query.channel || null
    },

    isWorkflowCampaign() {
      return this.campaignType === campaignTypeEnum.TYPE_WORKFLOW
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}/analytics/${this.channel}`,
        params: {
          date_from: this.dateFrom,
          date_to: this.dateTo
        }
      })
    },

    exportTableMethod() {
      if (this.isWorkflowCampaign) {
        return 'campaign_workflow_' + this.channel + '_variants_list'
      }
      return 'campaign_variants_list'
    }
  }
}
</script>

<style scoped lang="scss">
i.winner {
  float: right;
  font-size: 18px;
}
.chart-ct {
  /deep/ .graphWrapper {
    height: 330px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/analytics/components/StatisticsTab.vue